import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
import { Content, TDocumentDefinitions } from "pdfmake/interfaces";

interface IItenssolicitacao {
  iditem: string;
  idsolicitacao: string;
  qtd: number;
  descricao: string;
  datalan: Date;
  un: string;
  referencia: string;
  urgente: boolean;
  status: number;
}
interface IGetSolicitacao {
  idsolicitacao: string;
  idlocalizacao: string;
  solicitante: string;
  dataabertura: Date;
  dataenvio: Date;
  obs?: string;
  status: number;
  item: IItenssolicitacao[];
}
async function PDFSolicitacao(dados: IGetSolicitacao, localizacao: string) {
  try {
    if (!pdfMake.vfs) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
    }
    const createDefaultImage = (): string => {
      const canvas = document.createElement('canvas');
      canvas.width = 100;
      canvas.height = 100;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.fillStyle = '#f0f0f0';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#666';
        ctx.font = '12px Arial';
        ctx.fillText('Logo', 30, 50);
      }
      return canvas.toDataURL('image/png');
    };
    const loadImage = async (url: string): Promise<string> => {
      return new Promise((resolve) => {
        if (!url) {
          resolve(createDefaultImage());
          return;
        }
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = () => resolve(createDefaultImage());
        img.src = url;
      });
    };
    const logoImage = await loadImage('/logo.ico');
    const wrapText = (text: string, limit = 300): string => {
      if (!text) return "";
      const parts = [];
      for (let i = 0; i < text.length; i += limit) {
        parts.push(text.substring(i, i + limit));
      }
      return parts.join("\n");
    };
    const gerarCodigoSimples = (uuid: string): number => {
      const last = uuid.split('-').pop()!;
      return parseInt(last.substring(0, 4), 16);
    };
    const dataHoraEnvio = moment(dados.dataenvio).format('DD/MM/YYYY HH:mm');
    const codigoSolicitacao = gerarCodigoSimples(dados.idsolicitacao);
    const content: Content[] = [
      {
        stack: [
          {
            canvas: [
              {
                type: 'rect',
                x: 0,
                y: 0,
                w: 515,
                h: 70,
                color: '#f0f9f0',
                fillOpacity: 0.5
              }
            ],
            absolutePosition: { x: 40, y: 20 }
          },
          {
            columns: [
              {
                image: logoImage,
                width: 60,
                margin: [0, 5, 15, 0]
              },
              {
                stack: [
                  {
                    text: [
                      { text: 'SOLICITAÇÃO', style: 'header' },
                      { text: ` — ${codigoSolicitacao}`, style: 'codigoGrande' }
                    ],
                    margin: [0, 5, 0, 10]
                  },
                  {
                    columns: [
                      {
                        stack: [
                          {
                            text: [
                              { text: 'Local: ', style: 'infoLabel' },
                              { text: localizacao, style: 'infoValue' }
                            ]
                          },
                          {
                            text: [
                              { text: 'Solicitante: ', style: 'infoLabel' },
                              { text: `${dados.solicitante} `, style: 'infoValue' },
                            ],
                            margin: [0, 3, 0, 0]
                          }
                        ],
                        width: '50%'
                      },
                      {
                        stack: [
                          {
                            text: [
                              { text: 'Data/Hora: ', style: 'infoLabel' },
                              { text: dataHoraEnvio, style: 'infoValue' }
                            ],
                            alignment: 'right',
                            margin: [0, 0, 10, 0]
                          },
                          {
                            text: [
                              { text: 'Itens: ', style: 'infoLabel' },
                              { text: dados.item.length.toString(), style: 'infoValue' }
                            ],
                            alignment: 'right',
                            margin: [0, 3, 10, 0]
                          }
                        ],
                        width: '50%'
                      }
                    ]
                  }
                ],
                width: '*'
              }
            ],
            margin: [0, 0, 0, 0]
          }
        ]
      },
      {
        table: {
          headerRows: 1,
          widths: ['3%', '8%', '15%', '*', '18%'],
          body: [
            [
              { text: '', style: 'tableHeader' },
              { text: 'Qtd', style: 'tableHeader', alignment: 'center' },
              { text: 'Un - Pat', style: 'tableHeader', alignment: 'center' },
              { text: 'Descrição', style: 'tableHeader' },
              { text: 'Referência', style: 'tableHeader', alignment: 'center' },
            ],
            ...dados.item.map(item => [
              {
                text: item.urgente ? '!!!' : '',
                alignment: 'center',
                style: item.urgente ? 'urgentIcon' : undefined
              },
              {
                text: new Intl.NumberFormat('pt-BR').format(item.qtd),
                alignment: 'center',
                style: item.urgente ? 'urgentText' : undefined
              },
              {
                text: item.un,
                alignment: 'center',
                margin: [0, 3, 0, 3]
              },
              {
                text: wrapText(item.descricao, 50),
                noWrap: false,
                alignment: 'left',
                margin: [0, 3, 0, 3],
                style: item.urgente ? 'urgentText' : undefined
              },
              {
                text: item.referencia || '-',
                alignment: 'center',
                margin: [0, 3, 0, 3]
              },
            ])
          ]
        },
        layout: {
          hLineWidth: () => 0.8,
          vLineWidth: () => 0.8,
          hLineColor: () => '#000000',
          vLineColor: () => '#000000',
          paddingTop: () => 2,
          paddingBottom: () => 2
        },
        margin: [0, 5, 0, 0]
      },
      {
        text: [
          { text: 'Observações: ', style: 'obsLabel' },
          { text: dados.obs || '', style: 'obsValue' }
        ],
        margin: [0, 15, 0, 20]
      }
    ];
    const docDefinition: TDocumentDefinitions = {
      pageSize: 'A4',
      pageMargins: [40, 20, 40, 40],
      content,
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          color: '#1B5E20'
        },
        codigoGrande: {
          fontSize: 22,
          bold: true,
          color: '#1B5E20'
        },
        infoLabel: {
          fontSize: 12,
          bold: true,
          color: '#37474F'
        },
        infoValue: {
          fontSize: 12,
          color: '#000000'
        },
        tableHeader: {
          bold: true,
          fontSize: 10,
          fillColor: '#f5f5f5',
          alignment: 'center'
        },
        urgentIcon: {
          bold: true,
          fontSize: 12,
          color: '#FF0000'
        },
        urgentText: {
          bold: true,
          color: '#D32F2F'
        },
        obsLabel: {
          bold: true,
          fontSize: 11
        },
        obsValue: {
          fontSize: 11
        }
      },
      defaultStyle: {
        fontSize: 10,
        margin: [0, 1, 0, 1]
      }
    };
    const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.open();
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('Erro ao gerar o PDF. Veja o console para mais detalhes.');
  }
}
export default PDFSolicitacao;